import { useContext, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom/';

import { TEACHERS_PERMISSION_DENIED_URL } from 'config/urls';
import { getStandards } from 'sdk';

import { buildFilters } from 'utils/filters';
import { useFetch } from 'utils/sdk';
import { reverse } from 'utils/urls';

import UserContext from 'components/UserContext';

export const useStandards = (selectedStandardsIds) => {
  const [standardSearchValue, setStandardSearchValue] = useState('');

  const params = useMemo(
    () =>
      buildFilters({
        search: standardSearchValue,
        'exclude_standards[]': selectedStandardsIds
      }),
    [standardSearchValue, selectedStandardsIds]
  );

  const {
    data: { results: standards },
    loading: standardsLoading
  } = useFetch(getStandards, { data: { results: [] } }, params);

  return {
    standards,
    setStandardSearchValue,
    standardSearchValue,
    standardsLoading
  };
};

export const useRedirectForV2Users = () => {
  const history = useHistory();
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (user.is_ui_v2_user && user.is_teacher) {
      history.push({ pathname: reverse(TEACHERS_PERMISSION_DENIED_URL) });
    }
  }, [history, user]);
};
